<main class="mat-body" *ngIf="client && !isClientPortal">
    <div class="container">
        <div class="row">
            <div class="col-12 pt-3">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1
                            class="text-blue mat-display-1 font-weight-bold mb-0"
                            [innerHTML]="'test.sign.title'|translate"
                            *ngIf="!isSuitability"
                        ></h1>
                        <h1
                            class="text-blue mat-display-1 font-weight-bold mb-0"
                            [innerHTML]="'test.sign.suitability'|translate"
                            *ngIf="isSuitability"
                        ></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-sign-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1 mb-0" />
            </div>

            <div class="col-12">
                <div class="bg-gray-gradient px-2 pt-4 pb-5">
                    <form #formTestSign="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
                        <mat-radio-group name="signatory" required [(ngModel)]="signatureType">
                            <table class="table participants mb-5">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>{{ 'form.name-and-surname'|translate }}</th>
                                        <th class="d-none d-md-table-cell">{{ 'form.email'|translate }}</th>
                                        <th class="d-none d-md-table-cell">{{ 'form.phone'|translate }}</th>
                                        <th
                                            matTooltipPosition="above"
                                            matTooltipClass="blue-tooltip"
                                            [matTooltip]="'operative.sign-digital-face-to-face-help'|translate"
                                        >
                                            {{ 'operative.sign-digital-face-to-face'|translate }}
                                        </th>
                                        <th
                                            [class.d-none]="isClientPortal"
                                            matTooltipPosition="above"
                                            matTooltipClass="blue-tooltip"
                                            [matTooltip]="'operative.sign-digital-remote-help'|translate"
                                        >
                                            {{ 'operative.sign-digital-remote'|translate }}
                                        </th>
                                        <th
                                            [class.d-none]="isClientPortal"
                                            matTooltipPosition="above"
                                            matTooltipClass="blue-tooltip"
                                            [matTooltip]="'operative.sign-handwriting-help'|translate"
                                        >
                                            {{ 'operative.sign-handwriting'|translate }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <i class="icon-natural-plus"></i>
                                        </td>
                                        <td><strong>{{ client.name }}</strong>&nbsp;<strong>{{ client.surname }}</strong></td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ client.email }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ client.phone }}</strong>
                                        </td>
                                        <td class="text-center" width="80px">
                                            <mat-radio-button
                                                [name]="'radioSignature'"
                                                color="blue-gray"
                                                [value]="ClientSignatureType.IN_PERSON_ELECTRONIC"
                                                [disabled]="!client.email || !client.phone"
                                                required
                                            ></mat-radio-button>
                                        </td>
                                        <td class="text-center" [class.d-none]="isClientPortal" width="80px">
                                            <mat-radio-button
                                                [name]="'radioSignature'"
                                                color="blue-gray"
                                                [value]="ClientSignatureType.REMOTE_ELECTRONIC"
                                                [disabled]="!client.email || !client.phone"
                                                required
                                            ></mat-radio-button>
                                        </td>
                                        <td class="text-center" [class.d-none]="isClientPortal" width="65px">
                                            <mat-radio-button
                                                [name]="'radioSignature'"
                                                color="blue-gray"
                                                [value]="ClientSignatureType.HANDWRITTEN"
                                                required
                                            ></mat-radio-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </mat-radio-group>

                        <div class="row justify-content-end">
                            <div class="col-12 col-sm-6 col-md-4">
                                <button
                                    type="submit"
                                    class="full-width mat-elevation-z0"
                                    mat-raised-button
                                    color="blue"
                                    [disabled]="!formTestSign.valid"
                                >
                                    {{ 'general.sign'|translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</main>

<div class="d-none">
    <form #formLogalty name="formLogalty" id="formLogalty" method="POST" [attr.action]="formLogaltyAction">
        <input type="hidden" id="saml_assertion" name="saml_assertion" [attr.value]="formLogaltyXml" />
    </form>
</div>
